var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvidenceDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/document-download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 9.16699V14.167L9.16667 12.5003",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.49999 14.1667L5.83333 12.5",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.3333 8.33366V12.5003C18.3333 16.667 16.6667 18.3337 12.5 18.3337H7.50001C3.33334 18.3337 1.66667 16.667 1.66667 12.5003V7.50033C1.66667 3.33366 3.33334 1.66699 7.50001 1.66699H11.6667",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3333 8.33366H15C12.5 8.33366 11.6667 7.50033 11.6667 5.00033V1.66699L18.3333 8.33366Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidenceDownloadIcon);
export default __webpack_public_path__ + "static/media/evidence-download-icon.20defa86020d9d0598521366142c79b9.svg";
export { ForwardRef as ReactComponent };